import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import payments from './payment/reducer';
import common from './common/reducer';
import merchants from './merchant/reducer';
import devices from './device/reducer';
import membergroup from './membergroup/reducer';
import member from './member/reducer';
import service from './service/reducer';
import gateway from './gateway/reducer';
const reducers = combineReducers({
  menu,
  settings,
  authUser,
  payments,
  common,
  merchants,
  devices,
  membergroup,
  member,
  service,
  gateway
});

const initialState = reducers({}, {})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER') {
    state = initialState
  }

  return reducers(state, action)
}

export default rootReducer;
